/**
 * Module 7 — ThemeManager.
 *
 * The whole of it: put the chosen theme on the root element and let CSS do the
 * rest. Every colour in the app is a `--pm-*` variable defined in theme.css, so
 * there is nothing else to switch.
 */

import { useEffect } from "react";

import { useSettings } from "./SettingsContext";

export function useTheme(): void {
  const { settings } = useSettings();

  useEffect(() => {
    const root = document.documentElement;

    if (settings.theme === "system") {
      // No attribute at all, so the prefers-color-scheme rules apply unopposed.
      delete root.dataset.theme;
    } else {
      root.dataset.theme = settings.theme;
    }

    // Native controls — select popups, date pickers, scrollbars — follow this
    // rather than the CSS variables, so it has to be set separately.
    root.style.colorScheme =
      settings.theme === "light" ? "light" : settings.theme === "dark" ? "dark" : "light dark";
  }, [settings.theme]);
}
